import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from "rxjs/Subject";
import { ICON } from "../../../shared/constants";

declare const swal: any;

@Component({
  selector: 'drx-admin-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  providers: []
})
export class AdminTopbarComponent implements OnInit, OnDestroy {

  icon: string = ICON;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
  ) {
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.ngUnsubscribe.next(); // Emit a value
    this.ngUnsubscribe.complete(); // complete the observable
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/topbar/topbar.component.ts